// extracted by mini-css-extract-plugin
export default {"body":"Details_body__LBIfy","slideEnterAnimation":"Details_slideEnterAnimation__7Ihda","slideLeaveAnimation":"Details_slideLeaveAnimation__T5OJ3"};